import styled from 'styled-components';
import media from 'styled-media-query';

import ImageBgSp from '../../../static/image/lp/fv_bg_sp.png';
import ImageSlideSp1 from '../../../static/image/lp/fv_slide_sp1.png';
import ImageSlideSp2 from '../../../static/image/lp/fv_slide_sp2.png';
import ImageSlideSp3 from '../../../static/image/lp/fv_slide_sp3.png';

export const LpSpSlider = () => {
  return (
    <SlideContainer>
      <SlideWrapper>
        <Slide url={ImageSlideSp1} />
        <Slide url={ImageSlideSp2} />
        <Slide url={ImageSlideSp3} />
      </SlideWrapper>
    </SlideContainer>
  );
};

const SlideContainer = styled.div`
  display: none;
  height: 300px;
  margin: 2rem auto;
  overflow: hidden;
  position: relative;
  background: url(${ImageBgSp});
  background-size: cover;

  ${media.lessThan('medium')`
    margin: 0 auto;
    display: block;
  `};
`;
const SlideWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  animation: slide-animation 15s infinite;
  @keyframes slide-animation {
    0% {
      transform: translateX(0%);
    }
    33.33% {
      transform: translateX(0%);
    }
    40% {
      transform: translateX(-100%);
    }
    73.33% {
      transform: translateX(-100%);
    }
    80% {
      transform: translateX(-200%);
    }
    100% {
      transform: translateX(-200%);
    }
  }
`;
const Slide = styled.div<{ url: string }>`
  flex: 0 0 calc(100% - 1rem);
  margin: 0 0.5rem;
  background: url(${(props) => props.url}) center center / contain no-repeat;
`;
